
import React from 'react';
import InstrumentalResearchDetails from './Components/InstrumentalResearchDetails';

const InstrumentalResearchDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <InstrumentalResearchDetails />
      </div>
    </div>
  );
};

export default InstrumentalResearchDetailsPage;
